App.addModule(function(app) {

    if (!app.getConfigFlag('google/gtm/enabled') || !app.getConfig('google/gtm/container_id') || !app.getConfig('google/gtm/script_url')) {
        return
    }

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({'gtm.start': new Date().getTime(), event:'gtm.js'})

    app.on('consent:save', () => {
        window.dataLayer.push({event: 'consent'})
    })
	
    app.loadScript(app.getConfig('google/gtm/script_url'))
})
